export * from '@nuxt-common/schedule-delivery/config.bcom';
export * from '@nuxt-common/left-nav/config.bcom';
export * from '@nuxt-common/media-card-large/config.bcom';
export * from '@nuxt-common/product-quickview/config.bcom';
export * from '@nuxt-common/locator/config.bcom';
export * from '@nuxt-common/add-to-bag/config.bcom';
export * from '@nuxt-common/account-verification-component/config.bcom';

export const brand = 'bcom';
export const brandName = "Bloomingdale's";
export const returnsCenterLink = 'https://www.bloomingdales.com/returns';
export const onlineUid = 'bloomingdales_online_uid';
export const privacyLink =
  'https://www.bloomingdales.com/customer-service/articles/bloomingdales-and-bloomingdalescom-notice-of-privacy-practices#HowWeCollectInformation';
export const CUSTOMER_SERVICE = '1-800-777-0000';
export const WNM_UPSELL_EXPERIMENTATION_ID = 'xxxx-21';
export const CUSTOMER_SERVICE_BT = '1-800-323-7857';
export const CS_PHONE_NUMERIC = '1-800-777-0000'; // Enables the Product QuickView (PQV) ATB component to display the correct value in its slideout.
export const RETURN_ITEMS_ERROR = 'Sorry, We are unable to complete your returns at this time. Please try again later, or call us at 1-800-777-0000';
export const RMA_SHIPPING_DETAILS_ERROR =
  'Your return shipping label can’t be generated right now. Try again later, print the label from your return confirmation email, or call us at 1-800-777-0000.';
export const RMA_DEEPLINK_LABEL_ERROR = 'Your return shipping label can’t be generated right now. Try again later or call us at 1-800-777-0000.';
export const RETURN_INVALID_UPC =
  'Sorry, this item is invalid and we are unable to complete your return at this time. Please try again later, or call us at 1-800-777-0000';
export const RETURN_EMPTY_CARTON_LINE =
  'Sorry, this order is not eligible to be returned at this time. Please try again later, or call us at 1-800-777-0000';
export const RETURN_SUBMIT_ERROR = 'Sorry, We are unable to complete your returns at this time. Please try again later, or call us at 1-800-777-0000';
export const RETURN_DETAILS_ERROR = "Sorry, we can't access your return info right now. Please try again later, or call us at 1-800-777-0000";
export const FULLSCREEN_LOADER_MESSAGE = "We're processing your request, this may take a few moments";
export const PREPARE_DECLARATION_ERROR =
  'Sorry, We are unable to complete your request at this time. Please try again later, or call us at 1-800-777-0000';
export const latchkey = {
  label: '',
  minCountToShowDropdown: 0,
};
export const RETURN_METHOD_KEY_MAP = {
  ups: 'UPS',
  labelFree: 'LABEL-FREE',
  storeReturn: 'BSTORE',
  fedex: 'FEDEX',
  posReturn: 'STORE',
};
export const LOCATOR_LINK_TEXT = {
  config: (isBorisReturn) => ({
    UPS: 'UPS Locations Near You',
    BSTORE: isBorisReturn ? 'Find a Store' : 'Stores Near You',
    'LABEL-FREE': 'The UPS Stores Near You',
    FEDEX: 'Find a FedEx location',
  }),
};
export const SCAN_QR_TEXT = {
  config: (isBorisReturn) => ({
    UPS: '',
    BSTORE: isBorisReturn ? 'Scan for return details' : 'Scan in store',
    'LABEL-FREE': 'Scan at the UPS Store',
  }),
};
export const LOCATOR_TITLE = {
  UPS: 'UPS Locations Near You',
  BSTORE: "Bloomingdale's Stores Near You",
  'LABEL-FREE': 'The UPS Stores Near You',
  FEDEX: 'FedEx Locations Near You',
};
export const trackReturnSellerInstruction = 'You can track your return back to the seller.';
export const RETURN_METHODS = {
  config: (isBorisEnabled) => [
    {
      id: 'UPS',
      title: 'UPS Drop-Off',
      instructions: ['Package and label your return', 'Drop it off at convenient UPS locations'],
      shipment: 'FREE',
      locatorLinkText: 'Find a UPS Location',
    },
    {
      id: 'LABEL-FREE',
      title: 'Label-Free at The UPS Store',
      instructions: ['No printer needed—just package your return', 'The UPS Store will label and ship it for you'],
      shipment: 'FREE',
      locatorLinkText: 'The UPS Stores Near You',
    },
    {
      id: 'BSTORE',
      title: isBorisEnabled ? "Bloomingdale's Drop-Off" : "Bloomingdale's Store Return",
      instructions: isBorisEnabled
        ? ['Return items without packaging and', "Bloomingdale's will ship your return"]
        : ['Return without packaging', 'Process your refund on the spot'],
      shipment: 'FREE',
      locatorLinkText: isBorisEnabled ? 'Find a Store' : 'Stores near you',
    },
    {
      id: 'FEDEX',
      title: 'FedEx Drop Off',
      instructions: ['Print your label and package your return', 'Bring it to a nearby FedEx location'],
      shipment: 'FREE',
      locatorLinkText: 'Find a FedEx Location',
    },
  ],
};
export const BANK_REFUND_TEXT = 'Depending on your bank, it may take a few days for your refund to appear.';
export const REFUND_METHOD = {
  REPLACEMENT: 'REPLACEMENT',
  EXCHANGE: 'EXCHANGE',
  ORIGINAL: 'ORIGINAL',
  WALLET: 'WALLET',
  GIFT: 'GIFT',
  EGIFT: 'EGIFT',
};
export const OTP_ABANDONED_ERROR = 'Verify your email to return as store credit.';
export const EXCHANGE_DRAWER = {
  title: 'Exchange Item',
  footer_title: 'Select for exchange',
  footer_message: "If the item you're looking for is unavailable online, try an in-store exchange at a Bloomingdale's near you for more options.",
  notification: 'Online exchange is limited to the items below, at the price you originally paid.',
  low_stock_message: 'Low Stock',
};
export const RETURN_RESOLUTIONS = {
  REPLACEMENT: 'REPLACEMENT',
  EXCHANGE: 'EXCHANGE',
  REFUND: 'REFUND',
};
export const REFUND_METHOD_TEXT = {
  REPLACEMENT: 'Replace with same item',
  EXCHANGE: 'Exchange size and/or color',
  ORIGINAL: 'Original Payment Method',
  GIFT: "Bloomingdale's Gift Card",
  EGIFT: "Bloomingdale's E-Gift Card",
  WALLET: 'Store credit',
};
export const FREE_SHIPMENT = 'FREE';
export const HAZMAT_INSTRUCTIONS = {
  packedItem: {
    key: 'Lithium Battery Hazmat - Packed with the item',
    text: 'This item has a lithium battery. The battery must be securely packed in its original packaging if available or in a separate box, within your return. Do not pack the item with any liquids, such as perfume, in the same box. A required hazmat label must be <strong aria-hidden="true">printed in color</strong><span class="visibility-hidden">printed in color</span> and attached to the package next to the return label.',
  },
  containedItem: {
    key: 'Lithium Battery Hazmat - Contained in the item',
    text: 'This item has a lithium battery. A required hazmat label must be <strong aria-hidden="true">printed in color</strong><span class="visibility-hidden">printed in color</span> and attached to the package next to the return label. Do not pack the item with any liquids, such as perfume, in the same box.',
  },
  standaloneItem: {
    key: 'Lithium Battery Hazmat - Standalone item',
  },
  title: 'Required for a lithium battery',
  help: (helpText) => `If the battery is damaged, contact ${helpText} for help with your return.`,
  note: 'Failure to follow legal requirements for returns with a lithium battery could lead to an unsuccessful return.',
};
export const RETURN_ITEMS_TITLE = 'Return or Exchange';
export const returnItems = {
  heading: 'Items to return',
  returnReason: 'Reason for return*',
  previewReturnReason: 'Reason: ',
  quantity: 'Select a quantity*',
  previewReturnQuantity: 'Quantity: ',
};
export const returnConfirmation = {
  pageTitle: {
    REPLACEMENT: 'Replacement Submitted',
    EXCHANGE: 'Exchange Submitted',
    REFUND: 'Return Submitted',
  },
  subHeader: {
    REPLACEMENT:
      'The items you’re returning must be dropped off and scanned at a UPS Location <strong>within 7 days</strong> before your new items can be shipped to you.*',
    REPLACEMENT_ARIA_LABEL:
      'The items you’re returning must be dropped off and scanned at a UPS Location within 7 days before your new items can be shipped to you.*',

    EXCHANGE:
      'The items you’re returning must be dropped off and scanned at a UPS Location <strong>within 7 days</strong> before your new items can be shipped to you.*',
    EXCHANGE_ARIA_LABEL:
      'The items you’re returning must be dropped off and scanned at a UPS Location within 7 days before your new items can be shipped to you.*',
  },
  ssreReturnDropOffWindow: {
    header: 'What happens if i miss the return drop off window?',
    instruction: (resolutionOption) =>
      `*If your return items are not dropped off <strong>within 7 days</strong>, your ${resolutionOption} will be canceled and we will issue you a refund once we receive and process your items.`,
    aria_label_instruction: (resolutionOption) =>
      `*If your return items are not dropped off within 7 days, your ${resolutionOption} will be canceled and we will issue you a refund once we receive and process your items.`,
  },
};
export const refundDetails = {
  estimatedRefundTotal: 'Estimated total refund',
  estimatedAmountDue: 'Estimated Amount Due',
};
export const refundOptions = {
  starMoney: 'Promotional Gift Card',
};
export const hazmatReturnInstructions = [
  'Print your free return label, slip, and hazmat labels. Hazmat labels must be <strong aria-hidden="true">printed in color.</strong><span class="visibility-hidden">printed in color</span>',
  'Make sure the device is turned off. Package your return items and attach the hazmat and return label.',
  'Drop it off at any UPS Access Point or The UPS Store.',
  'Get refunded after we receive and process your items.',
];
export const fedExHazmatReturnInstructions = [
  'Print your return label, hazmat label, and packing slip. Hazmat labels must be <strong aria-hidden="true">printed in color.</strong><span class="visibility-hidden">printed in color</span>',
  'Make sure the device is turned off. Package your return and attach the hazmat and return labels.',
  'Bring it to a nearby FedEx location.',
  'Get refunded after we receive and process your items.',
];
export const returnInstructions = {
  'UPS-TITLE': 'Shipping Instructions:',
  'BSTORE-TITLE': 'Return Instructions:',
  'LABEL-FREE-TITLE': 'Shipping Instructions:',
  'FEDEX-TITLE': 'Shipping Instructions:',
  'REPLACEMENT-TITLE': 'To complete your replacement:',
  'EXCHANGE-TITLE': 'To complete your exchange:',
  uopTitle: 'To Complete Your Return',
  'REPLACEMENT-DROP-OFF-TEXT': {
    text: 'Drop the package off at a ',
    cta: 'UPS location',
  },
  'EXCHANGE-DROP-OFF-TEXT': {
    text: 'Drop the package off at a ',
    cta: 'UPS location',
  },
  'EXCHANGE-LABEL-FREE-DROP-OFF-TEXT': {
    text: 'Bring your package to ',
    cta: 'The UPS Store',
  },
  'REPLACEMENT-LABEL-FREE-DROP-OFF-TEXT': {
    text: 'Bring your package to ',
    cta: 'The UPS Store',
  },
  'UPS-DROP-OFF-TEXT': {
    text: 'Drop it off at any ',
    cta: 'UPS Access Point or The UPS Store.',
  },
  'LABEL-FREE-DROP-OFF-TEXT': {
    text: 'Bring your package to ',
    cta: 'The UPS Store.',
  },
  'FEDEX-DROP-OFF-TEXT': {
    text: 'Bring it to a nearby ',
    cta: 'FedEx location.',
  },
  UPS: [
    'Print your return label and packing slip.',
    'Package your items with the packing slip and attach the label.',
    'Drop it off at any UPS Access Point or The UPS Store.',
    'Get refunded after we receive and process your items.',
  ],
  REPLACEMENT: [
    'Print your return label and packing slip.',
    'Package return items with packing slip and attach the label.',
    'Drop the package off at a UPS location near you by XXX XX/XX.*',
    'Get your new items shipped to you after UPS scans your drop-off.',
  ],
  EXCHANGE: [
    'Print your return label and packing slip.',
    'Package return items with packing slip and attach the label.',
    'Drop the package off at a UPS location near you by XXX XX/XX.*',
    'Get your new items shipped to you after UPS scans your drop-off.',
  ],
  'REPLACEMENT-LABEL-FREE': [
    'Package your return and include original packing slip if you have it.',
    'Bring your package to The UPS Store by XXX XX/XX.*',
    'Show the QR code to an associate.',
    'Your new items will be shipped once UPS scans your item.',
  ],
  'EXCHANGE-LABEL-FREE': [
    'Package your return and include original packing slip if you have it.',
    'Bring your package to The UPS Store by XXX XX/XX.*',
    'Show the QR code to an associate.',
    'Your new items will be shipped once UPS scans your item.',
  ],
  'LABEL-FREE': [
    'Package your return and include the original packing slip if you have it.',
    'Bring your package to The UPS Store.',
    'Show the QR code to an associate.',
    'Get refunded after we receive and process your items.',
  ],
  BSTORE: ['Bring your return items to a Bloomingdale’s near you.', 'Show this QR code to a Bloomingdale’s colleague.'],
  'BORIS-BSTORE': [
    'Bring the return items to the bHelpful desk at a Bloomingdale’s near you',
    'Share your order number with a Bloomingdale’s colleague',
    'Bloomingdale’s will ship the return items back to the seller for you',
    'Your refund will be issued when your return is processed by the seller',
  ],
  'BORIS-QR-BSTORE': [
    'Bring the return items to the bHelpful desk at a Bloomingdale’s near you',
    'Show this QR code to a Bloomingdale’s colleague so they can access your return details',
    'Bloomingdale’s will ship the return items back to the seller for you',
    'Your refund will be issued when your return is processed by the seller',
  ],
  FEDEX: [
    'Print your return label and packing slip.',
    'Package and label your return.',
    'Bring it to a nearby FedEx location.',
    'Get refunded after we receive and process your items.',
  ],
};
export const refundInfo = {
  one: {
    title: {
      default: 'Transit',
    },
    text: {
      mkp: (isBorisReturn) =>
        isBorisReturn
          ? 'It may take 2-6 business days for the seller to receive the items from Bloomingdale’s'
          : 'Your return is on its way back to the seller. It may take 2-6 days',
      default: (days) => `Shipped returns take ${days} business days to arrive back at Bloomingdale's.`,
    },
  },
  two: {
    title: {
      default: 'Processing',
    },
    text: {
      mkp: 'Once the items are received and processed by the seller, they will issue your refund and you will be notified.',
      default: (days) => `Once we receive your items, it takes ${days} business days to process them and issue your refund.`,
    },
  },
  three: {
    title: {
      default: 'Refund',
    },
    text: {
      mkp: (isBorisReturn) =>
        isBorisReturn
          ? 'Depending on your bank, it may take a few days for your refund to appear. Any amount paid with a Bloomingdale’s reward card will be refunded to your Bloomingdale’s Reward account.* If you chose an e-gift card, it’ll be sent to your return email within minutes.'
          : 'Depending on your bank, it may take a few days for your refund to appear. Any amount paid with Star Money will be refunded to your Star Rewards account.* If you chose an e-gift card, it’ll be sent to your return email within minutes.',
      vgc: 'Depending on your bank, it may take a few days for your refund to appear in your account. If you selected an e-gift card, it will be emailed to you once your return is processed.',
      default: (weeks) =>
        `Depending on your bank, your refund may take a few days to appear. Any amount paid with a Reward will be refunded to your Loyallist account. If you used a Gift Card or received the items as a gift, a new Gift Card will be mailed to you in ${weeks} weeks.`,
    },
  },
  notes: {
    jewelry: (days) =>
      `Fine jewelry and watches are inspected when returned. Please allow up to ${days} business days after we receive the item to complete inspection and issue a refund.`,
  },
};
export const refundOptionsText = {
  originalPayment:
    'If you used multiple payment methods, each will be refunded the original amount charged. If you received the items as a gift or used a Reward or Gift Card, a new Reward or Gift Card will be emailed to you.',
  giftCard: "We will mail you a new Bloomingdale's Gift Card once we receive and process your return.",
  eGiftCard: "We will email you a new Bloomingdale's Gift Card once we receive and process your return.",
  starMoneyAndOriginal:
    "The Promotional Gift Card you used on this purchase will be refunded as a Bloomingdale's Gift Card or an in-store Merchandise Certificate that you will receive by mail in 2-4 weeks.",
  giftCardAndOriginal:
    "You will receive a new Bloomingdale's Gift Card or an in-store Merchandise Certificate for the value of your refund. You will receive it by mail which you will receive in 2-4 weeks.",
  default: 'Your refund will be issued once we receive and process your return.',
  replace: (dropOffByDate) =>
    `If replacing, return items must be dropped off at a UPS Location by <strong>${dropOffByDate}</strong> in order to have your replacement items shipped to you.`,
  exchange: (dropOffByDate) =>
    `If exchanging, return items must be dropped off at a UPS Location by <strong>${dropOffByDate}</strong> in order to have your exchange items shipped to you.`,
};
export const REFUND_OPTIONS_SUB_TEXT = {
  paypal: 'We will credit your original payment PayPal account',
  Klarna: 'We will credit your original payment to Klarna',
};
export const RETURN_CENTER_TEXT = {
  startReturn: {
    type: 'START_RETURN',
    icon: 'order-status icon',
    title: 'START A RETURN',
    text: 'Return items purchased online or on our app.',
    url: '/account/signin?fromPage=easyReturn',
  },
  giftReturn: {
    type: 'GIFT_RETURN',
    icon: 'gift-wrap icon',
    title: 'GIFT RETURNS',
    text: 'Returning a gift? Our return process is easy and fast.',
    url: '/account/signin?fromPage=giftReturn',
  },
  returnFaqs: {
    type: 'FAQ_RETURN',
    icon: 'return icon',
    title: 'RETURN FAQS',
    text: 'Find answers about exchanges, refunds, and more.',
    url: 'https://www.bloomingdales.com/customer-service/articles/what-is-the-return-and-exchange-policy',
  },
};
export const GIFT_RETURN = {
  contact: "Don't have an order number? Call us at 1-800-777-0000 for assistance, or return your gift to any Bloomingdale's store.",
};
export const EASY_RETURN = {
  title: 'Start an easy return',
  step_one: {
    title: '1. Find your order',
  },
  step_two: {
    title: '2. Select and print',
    text: 'Select the item(s) to return, print confirmation page and mailing label(s).',
  },
  step_three: {
    title: '3. Pack and Ship',
    text: 'Pack your items along with the confirmation page and attach the shipping label. You can ship it from any <a href="https://www.ups.com/dropoff" target="_blank">UPS access point</a>',
  },
  step_four: {
    title: 'Or, return to a Store',
    text: 'Online orders can be returned to any <a href="https://www.bloomingdales.com/stores/" target="_blank">Bloomingdale’s location</a>. However, we cannot accept bloomingdales.com returns at any of our outlet stores.',
  },
  note: 'Free returns on online orders. Excludes Gift Cards, furniture, mattresses, mirrors, lamps, and wall art. Valid when shipping within the U.S. only. No adjustments to prior purchases.',
};
export const RMA_DETAIL = {
  SSRE: {
    RETURNING_TITLE: 'Items you’re returning',
    RECEIVING_TITLE: 'Items you’re receiving',
  },
  RETURN_REQUIRED: {
    TYPE: 'RETURN_REQUIRED',
    TITLE: 'Items to ship',
    SUMMARY_TITLE: 'Items to ship',
  },
  REFUND_RETURN_NOT_REQUIRED: {
    TYPE: 'REFUND_RETURN_NOT_REQUIRED',
    TITLE: 'Your return is complete, and you can keep the items.',
    DESCRIPTION: 'Your refund is on the way and may take a few days to appear.',
    SUMMARY_TITLE: 'Items to keep',
  },
  RETURN_ITEM: {
    TITLE: 'Items to return',
  },
};
export const ORDER_HISTORY = {
  orderHistoryHeading: 'Purchases & Returns',
  onlineHistory: {
    noOrdersMessage: "We can't find any orders on your account, try searching by order number and email address using the order lookup",
    onlineFallbackError: 'At this time we are unable to retrieve your online order information. Please try again later.',
  },
  orderLookupLabel: 'Order Lookup',
  searchPlaceholder: 'Search by product, brand, or category',
  applyDateFilterTag: {
    event_name: 'online purchase and returns.order date filter',
    link_name: 'online purchase and returns.order date filter',
  },
  onlineHistoryTag: {
    page_type: 'my account',
    customer_type: 'signed in',
    page_name: 'online purchase & returns',
    product_finding_method: 'buy again',
  },
  inStoreHistory: {
    routeName: 'in-store-history',
    noCardInWalletMessage: 'Want to view your in-store purchase? Add any credit cards you’ve used in store to your bWallet',
    noOrdersMessage: "Don't see what you're looking for? Try selecting a different date range.",
    inStoreFallbackError: 'At this time we are unable to retrieve your store order information. Please try again later.',
    addCardToWalletLabel: 'Add Card to Wallet',
    inStoreHistoryTag: {
      page_type: 'my account',
      customer_type: 'signed in',
      page_name: 'in store purchase & returns',
    },
  },
  orderCardHeader: {
    purchaseLabel: 'Purchased on',
    orderText: 'Order #',
  },
  shipmentReRoutedMessage:
    'Your chosen UPS Access Point was not available for this delivery. Your order will be available for pickup from another UPS Access Point.',
  trackPackageLabel: 'Track Package',
  multipleOrdersLabel: 'Multiple Orders',
  placedOnLabel: 'Placed on',
  purchaseDetailsLabel: 'Purchase Details',
  returnDetailsLabel: 'Return Details',
  trackPickUpLabel: 'Track Pick Up',
  exchangeDetailsLabel: 'Exchange Details',
  replacementDetailsLabel: 'Replacement Details',
};
export const PAYMENT_DETAILS = {
  pendingText: 'Pending',
  creditText: 'Credit',
  otherCreditText: 'Other Credit',
  paymentDetailsText:
    'Charges and credits are processed on the date of each transaction, but there may be a slight difference between dates shown below and dates reported by your bank on your credit or debit card statement.',
};
export const ORDER_DETAILS = {
  orderDetailsHeading: 'Order Details',
  pageTitle: 'Online Order Details',
  cancelOrderText: 'Cancel Order',
  bigTicket: {
    questionHeading: 'Questions about delivery scheduling or furniture and mattress returns?',
    questionNote: (customerServiceBT) =>
      `Call us at ${customerServiceBT}. Please note: changes made to your order via phone will not be reflected here.`,
    furnitureHeading: 'Furniture or mattress delivery',
    furnitureNote: 'Need to schedule a delivery or track an item in transit?',
    scheduleButtonLabel: 'Schedule & Track Deliveries',
    salesCheckNumber: (salesCheckNumber) => `Sales Check #: ${salesCheckNumber}`,
  },
  orderInformation: {
    cancelItemText: 'Cancel item',
    returnDetailsText: 'Return Details',
    confirmShippingText: 'Confirm your shipping',
    scheduleDeliveryText: 'Schedule Delivery',
    moreInfoText: 'More Information',
    trackPackageText: 'Track Package',
  },
  notification: {
    returnServiceDownText: 'The return information is not available, please check back later.',
    shippingStatusText: "Thanks for choosing to wait. We'll let you know when your item ships.",
    accessPointText:
      'Your chosen UPS Access Point was not available for this delivery. Your order will be available for pickup from another UPS Access Point.',
    trackPackageText: 'Track Package',
  },
  barcodeSection: {
    barcodeItemText: 'Present this barcode with the items being returned to any Bloomingdale’s store.',
    barcodeReturnPolicyText: 'Return Policy',
  },
  orderDetailsTag: {
    page_name: 'order details',
    page_type: 'my account',
    product_finding_method: 'buy again',
  },
  cancelOrderTag: {
    site_action: 'cancel order start',
    action_location: 'order details',
  },
  backOrderConfirmationTag: {
    site_action: 'back order confirmation start',
    action_location: 'order details',
  },
  bigTicketOrderTag: {
    site_action: 'big ticket order schedule start',
    action_location: 'order details',
  },
  orderDetailsTrackTag: {
    event_name: 'order details.track package',
    link_name: 'order details.track package',
    cta_to_pageview: true,
  },
  backOrderCancelTag: {
    site_action: 'back order cancellation start',
    action_location: 'order details',
  },
  cancelOrderModalTitleText: 'Cancel order?',
  confirmCancelItemModalText: 'Cancel Item?',
  confirmChoiceModal: {
    yourChoiceText: 'Confirm your choice',
    toWaitText: 'Confirm to wait',
  },
  scheduleDeliveryTag: {
    event_name: 'big ticket order schedule',
    link_name: 'big ticket order schedule',
    cta_to_pageview: true,
  },
  cancelOrder: {
    title: (orderNumber, total) => `Order ${orderNumber} for ${total} will be canceled.`,
    help: `Please note: This will cancel your entire order. If you’d like to modify
        items in your order, call Customer Service at`,
    tag: {
      site_action: 'cancel order complete',
      action_location: 'order details',
    },
  },
  pickupInfoText: 'Pickup Information',
  viewStoreInfoText: 'View Store Information',
  shippingInfoText: 'Shipping Information',
  shippingAddressPrivacyMessage: 'Shipping address not shown for privacy.',
  storeHoursLabel: 'Store Hours',
  pickupPersonLabel: 'Pickup Person',
  giftMessageCard: {
    giftMessageText: 'Gift Message',
  },
  exchangeInformationMessage:
    'The original delivery address is below. If you requested a different address for your exchange or replacement, it will appear in the exchange or replacement details.',
  paymentInformation: {
    paymentInfoText: 'Payment Information',
    doorDashShippingText: 'Doordash Shipping',
    giftWrapFeeText: 'Giftwrap Fee',
    eWasteRecyclingFeeText: 'eWaste Recycling Fee',
    otherFeesText: 'Other Fees',
    totalFeesText: 'Total Fees',
    protectionPlanLabel: 'Allstate Protection Plan',
    returnLabelFeeText: 'Return Shipping Fee',
    taxText: 'Tax',
    totalText: 'Total',
    subtotalText: 'Subtotal',
    estimatedTax: 'Estimated Tax',
    batteryFeeText: 'CA embedded battery fee',
    estimatedReturnShippingFee: 'Estimated Return Shipping Fee',
    viewAllTransactionsText: 'View all transactions',
  },
  marketPlaceSellerDetails: {
    sellerInformationTitleText: 'Seller Information',
    sellerInfoText:
      'Please contact Bloomingdale’s Customer Service at 1-800-777-0000 or customerservice@bloomingdales.com for help with this order. The seller engages in the manufacturing, importing, or reselling of consumer products.',
    chevronDown: 'chevron-small-down',
    chevronUp: 'chevron-small-up',
    viewLessText: 'View Less',
    viewMoreText: 'View More',
    mkpSellerFallbackError:
      'Sorry, we can\'t access seller info right now. Please try again later, or call us at <a href="tel:18007770000" style="color:inherit">1-800-777-0000</a>.',
  },
  paymentDetailsTitle: 'Transactions',
  orderDetailsFallbackError:
    'Sorry, we can\'t access your order info right now. Please try again later, or call us at <a href="tel:18007770000" style="color:inherit">1-800-777-0000</a>.',
  giftReturnFallbackError: "We're unable to find an order matching the info provided. Please double check and re-enter the information.",
  cancelOrderFallbackError: 'Sorry, we could not process your request. Please try again later, or call us at <u>1-800-777-0000</u>.',
  backOrderConfirmationFallbackError: 'Sorry, we could not process your request. Please try again later, or call us at <u>1-800-777-0000</u>.',
  orderLookupFailedAttemptsMessage: 'We’re still unable to find your order. For help, please call us at 1-800-777-0000.',
  protectionPlanPendingMessage: 'Your protection plan is being processed, you will receive an email from Allstate when the plan is confirmed.',
};
export const TRANSFORM_PRODUCT = {
  thereWasErrorText: 'There was an error loading the item information. Try again later',
  productBrandText: 'Brand Name',
  itemNameText: 'Item Name',
};
export const ORDER_LOOKUP = {
  orderLookupHeading: 'Order and Furniture Lookup',
  orderNumberLabel: 'Order Number',
  emailAddressLabel: 'Email Address',
  orLabel: 'or',
  phoneNumberLabel: 'Phone Number',
  shippingZipcodeLabel: 'Shipping Address Zipcode',
  viewOrderText: 'View Order',
  internationalOrderLinkText: 'Look up an international order',
  viewPurchaseHistoryText: 'View your purchase history',
  signInMessage: 'If you have an account you can view the status and details of your online orders and store purchases.',
  signInText: 'Sign In',
  lookupAnOrderText: 'Look up an order',
  lookupOrderMessageForLarge: 'View order status, tracking, and details or check and schedule a Furniture and mattress delivery',
  lookupOrderMessage: 'View order status, tracking, and details',
  searchOrderText: 'Search for an order',
  furnitureAndMattressDeliveryText: 'Furniture & mattress delivery',
  receivingGiftText: "I'm receiving a gift",
  orderLookupTag: {
    event_name: 'purchase and returns.view order',
    link_name: 'purchase and returns.view order',
    cta_to_pageview: true,
  },
  orderLookupViewTag: {
    page_name: 'purchase and returns.order lookup.search order',
    page_type: 'my account',
  },
  noOrderNumberMessage: 'Enter your order number',
  maximumCharactersMessage: 'Must be maximum 20 characters',
  invalidOrderNumberMessage: 'Please enter a valid order number',
  salesCheckNumberText: 'Sales check number',
  deliveryDateText: 'Delivery Date',
  modelNumberText: 'Model Number',
  deliveryAddressText: 'Delivery Address',
  deliveryWindowText: 'Delivery Window',
  deliveryTypeText: 'Delivery Type',
  scheduleDeliveryText: 'Schedule Delivery',
  deliveryChangeText: 'Schedule a delivery or change a furniture or mattress delivery date or manage your notification settings',
  easySchedulingText: 'Please have your sales check number ready for easy scheduling',
  deliveryStatusText: 'Check your delivery status',
  orderArrivalText: 'To see when your furniture or mattress will arrive, fill out the form below',
  deliveryStatusNote:
    'Note: delivery status information is only available the day before delivery and provides time-window information, driver ETA (where available) and summary of items being delivered for the sales check number entered.',
  nameText: 'Name',
  ETAText:
    '*The ETA is an ESTIMATE ONLY and is subject to change without notice. You must be available to receive delivery during the entire delivery window.Check this site on your scheduled delivery date for updates to the ETA.',
  checkStatusForm: {
    salesCheckNumberLabel: 'Sale’s Check Number',
    checkStatusLabel: 'Check Status',
    salesCheckNumberErrMsg: 'Sale’s Check Number must be at least 1 digit',
    privacyPracticesLabel: 'Privacy Practices',
    continueAgreeLabel: 'By continuing, you agree to',
  },
  internationalLookup: {
    title: 'International Order Tracking',
    message: 'View and track your orders! Enter your order number and billing email address below.',
  },
  requiredField: '*Required field',
  furnitureFallbackError: "Sorry, we can't access your order info right now. Please try again later, or call us at <u>1-800-777-0000</u>.",
  furnitureFallbackErrorMew:
    'We are unable to retrieve your information due to technical difficulties. Please contact Customer Service at 1-800-777-0000.',
  furnitureLookupViewTag: {
    page_name: 'purchase and returns.order lookup.furniture',
    page_type: 'my account',
  },
  scheduleDeliveryTag: {
    event_name: 'schedule delivery',
    link_name: 'schedule delivery',
  },
};
export const NEED_HELP = {
  needHelpLabel: 'Need help? ',
  visitLabel: 'Visit the ',
  faqLabel: 'FAQs',
  orCallLabel: ' or Call',
  contactSellerLabel: 'Contact seller',
  furnitureFaqUrl: 'https://www.bloomingdales.com/customer-service/category/furniture-and-mattresses',
  faqUrl: 'https://www.bloomingdales.com/customer-service/',
  helpLineUrl: 'https://www.bloomingdales.com/customer-service/articles/contact-us',
};
export const BACK_ORDER_CONFIRMATION = {
  waitText: 'If you wait, your item will be shipped to you when it’s back in stock.',
  cancelItemText: 'You can also cancel your item now.',
  waitForItemText: 'Wait for item',
  cancelItemConfirmationText: 'Cancel item',
  modalTitleText: 'Cancel Item?',
  tag: {
    siteActionText: 'back order confirmation complete',
    actionLocationText: 'order details',
    customLinkNameForOpenModalText: 'cancel item',
    customLinkNameForWaitForItemText: 'back order wait for item',
  },
};
export const BACK_ORDER_CANCEL_CONFIRMATION = {
  cancelConfirmationButtonText: 'Yes',
  cancelPreventButtonText: 'No',
  cancelOrderText: 'Are you sure you want to cancel your order of ',
  cancelItemText: 'Are you sure you want to cancel your item?',
  tag: {
    siteActionText: 'back order cancellation complete',
    actionLocationText: 'order details',
  },
};
export const BACK_ORDER_CANCEL_ITEM_TRACK_PACKAGE = {
  cancelConfirmationButtonText: 'Yes',
  cancelPreventButtonText: 'No',
  cancelOrderText: 'Are you sure you want to cancel your order of',
  cancelItemText: 'Are you sure you want to cancel your item?',
  tag: {
    siteActionText: 'back order cancellation complete',
    actionLocationText: 'back order shipment details',
  },
};
export const TRACK_PACKAGE = {
  titleText: 'Tracking',
  trackingDetailsText: 'Tracking Details',
  waitForItemText: 'Wait for item',
  cancelItemText: 'Cancel item',
  showBarcodeText: 'Show this barcode to a colleague',
  useCurbsideText: 'Use Curbside Pickup',
  colleagueMeetText: 'A colleague will meet you outside',
  confirmShoppingText: 'Confirm your shipping',
  scheduleDeliveryText: 'Schedule Delivery',
  signedInText: 'signed in',
  guestText: 'guest',
  trackPackageFallbackError: 'Tracking info is unable to load or expired',
  pageName: {
    STH: 's2h shipment details page',
    SDD: 'sdd shipment details page',
    BOSS: 'boss shipment details page',
    BOPS: 'bops shipment details page',
    VGC: 'gift card shipment details page',
    EGC: 'gift card shipment details page',
    S2AP: 's2ap shipment details page',
  },
  backorderTag: {
    page_name: 'backorder shipment details page',
    page_type: 'my account',
    order_method: 'backorder',
    product_finding_method: 'buy again',
  },
  bigticketTag: {
    page_name: 'bigticket shipment details page',
    page_type: 'my account',
    order_method: 'bigticket',
    product_finding_method: 'buy again',
  },
  guestTag: {
    page_type: 'my account',
    product_finding_method: 'buy again',
  },
  confirmCancelTag: {
    site_action: 'back order cancellation start',
    action_location: 'back order shipment details',
  },
  waitForItemTag: {
    site_action: 'back order confirmation complete',
    action_location: 'back order shipment details',
    custom_link_name: 'back order wait for item',
  },
  curbsideTag: {
    event_name: 'shipment details page.use curbside pickup',
    link_name: 'shipment details page.use curbside pickup',
  },
  scheduleDeliveryTag: {
    site_action: 'big ticket order schedule start',
    action_location: 'big ticket shipment details',
  },
  trackDetailsTag: {
    event_name: 'shipment details page.',
    custom_link_name: 'shipment details page.',
  },
  notification: {
    willingToWaitText: "Thanks for choosing to wait. We'll let you know when your item ships.",
    shipmentReRoutedText:
      'Your chosen UPS Access Point was not available for this delivery. Your order will be available for pickup from the UPS Access Point below.',
  },
  trackingDetails: {
    shippedWith: 'Shipped with',
    trackingNumber: 'Tracking # ',
    trackingDetailsFallbackError: 'No tracking info available',
    pageName: {
      STH: 's2h shipment details.tracking details',
      SDD: 'sdd shipment details.tracking details',
      BOSS: 'boss shipment details.tracking details',
      BOPS: 'bops shipment details.tracking details',
      VGC: 'gift card shipment details.tracking details',
      EGC: 'gift card shipment details.tracking details',
      S2AP: 's2ap shipment details.tracking details',
    },
    backOrderTag: {
      page_type: 'my account',
      page_name: 'backorder shipment details.tracking details',
    },
    bigTicketTag: {
      page_type: 'my account',
      page_name: 'bigticket shipment details.tracking details',
    },
    trackingNumberTag: {
      event_name: 'tracking details tracking number click',
      link_name: 'tracking details tracking number click',
    },
  },
  deliveryInformationText: 'Delivery Information',
  orderInformationText: 'Order Information',
  orderText: 'Order #',
  whereToGoText: 'Where to Go',
};
export const MARKETPLACE_CONTACT_SELLER = {
  assistAndGetBackText: 'Please fill out all fields so the seller can better assist you and get back to you more quickly.',
  assistWithReturnText: 'Please fill out all fields so the seller can better assist you with your return.',
  reasonForContactLabel: 'Reason for contact*',
  subjectLabel: 'Subject (brief description)*',
  reasonForReturnLabel: 'Reason for return*',
  havePackagingLabel: 'Do you have packaging for return?*',
  timeForPickupLabel: 'Best time for item pickup*',
  contactMethodLabel: 'Preferred contact method*',
  detailsPlaceholder: 'Give us all the details (Optional)',
  detailsLabel: 'Give us all the details',
  validationMessage: 'Please select an option.',
  noteText: 'Please note: For security reasons do not include links, credit card numbers, or any other personal information in your message.',
  toSellerText: 'To seller:',
  errorMessage: 'Your message could not be sent. Please try again or call us at 1-800-777-0000.',
  successMessageForContact:
    'This seller will contact you within 2 business days via the email address or phone number you provided when purchasing this item.',
  successMessageForReply: 'The seller will reply to the email address you provided when purchasing this item within 2 business days.',
  footerButtonBackLabel: 'Back to Purchases & Returns',
  footerButtonSubmitLabel: 'Submit',
  footerButtonSendMessageLabel: 'Send Message',
  validateTextAreaDetailsMessage: 'Please provide some details',
  validateTextAreaMinimumCharacterMessage: 'Please provide a minimum of 3 characters',
  validateInputSubjectMessage: 'Please provide a subject',
  validateInputMinimumCharacterMessage: 'Please provide a minimum of 3 characters',
  originText: 'item_details',
  tag: {
    validate: {
      event_name: 'error link',
      error_category: 'post-purchase',
      error_code: [''],
      error_label: ['Invalid_Contact_Reason'],
      error_scope: ['field'],
      error_message: ['Reason for contact is required'],
      error_misc: [''],
    },
    success: {
      event_name: 'content link click',
      link_name: 'marketplace:send message',
      site_action: 'marketplace contact seller complete',
      action_location: 'item details',
    },
    submitSuccessReasonForReturnText: 'mp:',
    error: {
      event_name: 'error link',
      error_category: 'post-purchase',
      error_label: ['API_Message_Not_Sent'],
      error_scope: ['global'],
      error_misc: [''],
    },
  },
};
export const PURCHASE_DETAILS = {
  title: 'Purchase Details',
  pageTitle: 'Store Purchase Details',
  purchasedText: 'Purchased',
  returnedText: 'Returned',
  barcodeMessage: 'Present this barcode with the items being returned to any Bloomingdale’s store.',
  returnPolicyText: 'Return Policy',
  tag: {
    page_name: 'instore order details',
    page_type: 'my account',
  },
  defaultItemErrorMessage: 'There was an error loading the item information. Try again later',
};
export const PRODUCT_THUMBNAIL_WRAPPER = {
  loyaltyByPassText: 'Unlimited return window',
  tooltipMessage: 'Top of the List and Top of the List Unlocked members enjoy an unlimited return window while your status is active.',
  notEligibleInStoreReturns: 'Item is not eligible for in-store returns',
};
export const PPE_ERROR_TAG = {
  defaultErrorCode: 999,
  error: {
    event_name: 'ppe error',
    error_category: 'my account',
    error_label: [''],
    error_scope: ['global'],
    error_misc: [''],
  },
};
export const SHIPPING_ADDRESS_SECTION = {
  title: 'Delivery Address',
  default: 'Default',
};
export const PROTECTION_PLAN_SLIDEOUT = {
  title: 'Protection Plan Details',
  button_label: 'Close',
  contact_info: '#',
  view_details: 'View Details',
  terms_and_conditions: {
    url: '#',
    label: 'Terms & Conditions',
  },
  faq: {
    url: '#',
    label: 'Frequently Asked Questions',
  },
  error_message: 'Sorry, We are unable to complete your request at this time. Please try again later.',
};
